import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { randomId } from '@sc/utils';

@Component({
  selector: 'sc-info-badge',
  styleUrls: ['./info-badge.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: ` <div class="info-badge">
    <div class="info-badge-side">
      <sc-icon name="info" specificName="info_badge_info_icon"></sc-icon>
    </div>
    <div class="info-badge-body">
      <p
        [id]="infoBadgeTitleId"
        class="info-badge-body-title sc-design-title-card"
        *ngIf="displayTitle"
        tabindex="-1"
        role="heading"
        [attr.aria-level]="infoBadgeTitleLevel"
      >
        {{ infoBadgeTitle }}
        <sc-icon *ngIf="displayIcon" name="emoji_trust"></sc-icon>
      </p>

      <span class="info-badge-body-text sc-design-text-3">
        <p [innerHTML]="infoBadgeText"></p>
      </span>
    </div>
  </div>`,
  imports: [IconComponent, NgIf],
})
export class InfoBadgeComponent implements OnInit {
  @Input() infoBadgeTitle: string;
  @Input() infoBadgeTitleLevel = 2;
  @Input() infoBadgeTitleId: string;
  @Input() infoBadgeText: string;
  @Input() displayIcon: boolean;
  @Input() displayTitle = true;

  ngOnInit() {
    if (!this.infoBadgeTitleId) {
      this.infoBadgeTitleId = 'info-badge-title-id-' + randomId(8);
    }
  }
}
